// extracted by mini-css-extract-plugin
export default {"wrapper":"Face_style_wrapper__kSP2a","content":"Face_style_content__oplqK","rotate":"Face_style_rotate__IZVVg"};